// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"fb28216c","978":"5072e87a"}[chunkId] + ".chunk.js";
};